import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Compass, ArrowRight } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between p-10 bg-primary text-primary-foreground">
        <Link to="/" className="flex items-center gap-2" data-testid="register-brand">
          <div className="w-7 h-7 bg-white text-primary flex items-center justify-center"><Compass size={16} weight="bold" /></div>
          <span className="font-display text-xl">DKK Info Tech</span>
        </Link>
        <div>
          <div className="overline text-white/70 mb-4" style={{ color: "rgba(255,255,255,0.75)" }}>Get started</div>
          <h2 className="font-display text-5xl leading-none tracking-tighter">Everything you need to pass the AI Governance interview.</h2>
          <p className="text-white/80 mt-6 max-w-md">Free forever for individual learners.</p>
        </div>
        <div className="text-xs font-mono uppercase tracking-widest text-white/60">NIST · ISO · EU AI ACT</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="register-form">
          <div>
            <div className="overline mb-2">Create account</div>
            <h1 className="font-display text-4xl tracking-tighter">Start free</h1>
          </div>
          <label className="block">
            <div className="text-xs font-medium uppercase tracking-widest mb-1">Full name</div>
            <input required value={name} onChange={(e) => setName(e.target.value)}
              className="w-full border border-border px-3 py-2 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
              data-testid="register-name" />
          </label>
          <label className="block">
            <div className="text-xs font-medium uppercase tracking-widest mb-1">Email</div>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-border px-3 py-2 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
              data-testid="register-email" />
          </label>
          <label className="block">
            <div className="text-xs font-medium uppercase tracking-widest mb-1">Password (min 6)</div>
            <input required minLength={6} type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-border px-3 py-2 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
              data-testid="register-password" />
          </label>
          <button disabled={busy} type="submit"
            className="w-full py-3 bg-primary text-primary-foreground text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-60 hover:bg-[color:hsl(223_100%_28%)] transition-colors"
            data-testid="register-submit">
            {busy ? "Creating…" : (<>Create account <ArrowRight size={14} weight="bold" /></>)}
          </button>
          <div className="text-sm text-muted-foreground">
            Have an account?{" "}
            <Link to="/login" className="text-primary font-medium underline underline-offset-4" data-testid="register-to-login">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
